import React from "react";
import { LoginForm, Notification } from "ra-ui-materialui";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import LockIcon from "@material-ui/icons/LockOutline";

const JBLogin = ({ classes }) => (
  <div className={classes.container}>
    <img
      src="https://assets.jbsurf.com/fichiers/internet/images/690/alpilink-blanc-point-rouge-750px.png"
      alt="jbconcept logo"
      className={classes.subImage}
    />
    <Card className={classes.card}>
      <div className={classes.avatar}>
        <Avatar className={classes.icon}>
          <LockIcon />
        </Avatar>
      </div>
      <LoginForm />
    </Card>
    <Notification />
  </div>
);

const styles = (theme) => ({
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minHeight: "100vh",
    height: "1px",
    justifyContent: "flex-start",
    alignItems: "center",
    background:
      "url(https://assets.jbsurf.com/fichiers/internet/images/690/elements-home/fond-bois.jpg)",
  },
  card: {
    minWidth: 300,
    marginTop: "6em",
  },
  subImage: {
    height: 50,
    position: "absolute",
    top: 20,
    left: 20,
  },
  avatar: {
    margin: "1em",
    display: "flex",
    justifyContent: "center",
  },
  icon: {
    backgroundColor: theme.palette.secondary[500],
  },
});

export default withStyles(styles)(JBLogin);



// WEBPACK FOOTER //
// ./src/components/login.js